import {Component, OnDestroy, OnInit} from '@angular/core';
import { DialogRef, DialogService } from '@progress/kendo-angular-dialog';
import {DomSanitizer} from "@angular/platform-browser";

@Component({
  selector: 'app-three-ds-dialog',
  template: `
     <h4>
       <i class="icone-autenticacao"></i>
       Autentique o cartão para continuar o pagamento

       <i class="k-i-loading k-icon mr-1"> </i></h4>

     <iframe *ngIf="usarIframe && sanitizedUrl" [src]="sanitizedUrl" title="Autenticação 3D Secure"></iframe>

     <p  class="mt-4">
       Se a autenticação não carregar, <a [href]="url" target="_blank" rel="noopener">abra em outra janela</a>.
     </p>

  `,
  styles: [`
    .icone-autenticacao{
      width: 50px;
      height: 50px;
      background-size: 50px;
      margin-bottom: 5px;
      top: 13px;
      position: relative;
      display: inline-block;
      background-image: url("/assets/icons/autenticacao-de-pagamento.png");
    }
    .k-i-loading{
      font-size: 30px;
    }
    iframe{
      width: 100%;
      min-height: 430px;
      border: 0;
    }
  `]
})
export class ThreeDSDialogComponent implements OnInit, OnDestroy {
  url;
  sanitizedUrl;
  usarIframe = false;
  private readonly messageHandler = (event: MessageEvent) => this.receiveMessage(event);

  constructor(  private dialogRef: DialogRef,  private sanitizer: DomSanitizer) {

  }

  ngOnInit(): void {
    window.addEventListener('message', this.messageHandler, false);
  }

  ngOnDestroy(): void {
    window.removeEventListener('message', this.messageHandler, false);
  }

  setUrl(url: string, usarIframe: boolean = false){
    this.url = url;
    this.usarIframe = usarIframe;
    this.sanitizedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);

    if(!this.usarIframe)
      setTimeout(() => window.location.href = this.url, 1500);
  }

  receiveMessage(event: MessageEvent): void {
    if (event.origin === window.location.origin &&
      ['cellcoin-3ds-return', '3ds-auth-success'].indexOf(event.data) >= 0)
      this.dialogRef.close({retornou: true});
  }

  close(): void {
    this.dialogRef.close();
  }
}
